import React, { useState, useEffect, useContext } from "react";
import "../styles/filing.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import DynamicIcon from "../components/dynamicicon";
import JisButton from "../components/controls/jisButton";
import JisDropdown from "../components/controls/jisDropdown";
import FlowItem from "../components/controls/flowitem";
import { ShareContext } from "../context/ShareContext";

import * as Constants from "../constants";
import BackLoader from "../components/backloader";
import Payment from "../components/core/payment";
import OTPInput from "../components/controls/otpinput";
import JisDialog from "../components/dialog";
import CaseSearch from "../components/core/case_search";
import JisEmptyList from "../components/controls/emptylist";
import JisCheckbox from "../components/controls/jisCheckbox";
import JisParty from "../components/controls/jisparty";
import JisDialogForm from "../components/formdialog";
import CustomSearchSortHeader from "../components/core/CustomSearchSortHeader";

function CaseAssociationRequest() {
  //the association flow
  //  and new can be initiated form there. table and search
  const FeeTYPEID = 31;
  const navigate = useNavigate();
  const [caseid, setCaseId] = useState(0);
  const [otp, setOtp] = useState("");
  const { activePage, token, profile, frequentData, setIsExpired } =
    useContext(ShareContext);
  const [cinfo, setCase] = useState(null);
  const [parties, setParties] = useState([]);
  const [flow, setFlow] = useState({ pos: 1, code: "search" });
  const [flowerror, setFlowError] = useState("");
  const [isOtp, setIsOtp] = useState(false);
  const [search, setSearch] = useState({});
  const [cases, setCases] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [selected, setSelected] = useState(new Set());
  const [party, setParty] = useState({
    isOrg: 0,
    isLead: true,
    state: Constants.Default_State,
  });
  const [err, setErr] = useState("");
  const [count, setCount] = useState(0);
  const [isPreview, setIsPreview] = useState(false);
  const [caseAssociationId, setCaseAssociationId] = useState(0);
  const [validate, setValidate] = useState(null); //{isApproved,IsAdminRequired}
  const [isResending, setIsResending] = useState(false);

  // useEffect(() => {
  //   if (otp.length == 6) {
  //     //validate the code
  //     console.log(otp);
  //     onValidateToken();
  //   }
  // }, [otp]);

  const onSaveParty = async (e) => {
    setFlowError("");
    setIsPreview(false);
    var _party = { ...e, isOrg: party.isOrg == "1" ? true : false };
    setLoading(true);
    try {
      const resp = await fetch(`${Constants.apiUrl}/filing/party/${caseid}`, {
        method: "POST",
        body: JSON.stringify(_party),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //update the field
        setParties((prev) => [...prev, { ..._party, id: data.id }]);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };
  const onAddParty = () => {
    setIsPreview(true);
  };
  const onSearch = async (sear) => {
    setSearch(sear);
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/search-cases/${pageIndex}/${pageSize}`,
        {
          method: "POST",
          body: JSON.stringify(sear),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setCases(data.items);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };
  const onContinue = async (caseid) => {
    setCaseId(caseid);
    await onLoadCase(caseid);
    setFlow({ pos: 2, code: "parties" });
  };
  const on_back_search = () => {
    setFlow({ pos: 1, code: "search" });
  };

  const onLoadCase = async (_caseid) => {
    //for account registration
    try {
      setSelected(new Set());
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/mini-case-details/${_caseid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setCase(data.caseinfo);
        setParties(data.parties);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onCheck = (value, id) => {
    let sel = selected;
    if (value) {
      sel.add(id);
    } else {
      sel.delete(id);
    }
    setSelected(new Set(sel));
  };
  const onSaveAssociation = async () => {
    var ids = Array.from(selected);

    setIsResending(true);
    setErr("");
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/case-association/${caseid}`,
        {
          method: "POST",
          body: JSON.stringify(ids),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setIsResending(false);
      console.log("data after onSaveAssociation");
      console.log(data);
      if (data.code == 0) {
        //update the field
        setCaseAssociationId(data.id);
        setIsOtp(true);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setIsResending(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };
  const onValidateToken = async (e) => {
    setErr("");

    var re = { id: caseAssociationId, token: otp };
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/case-association-validation/${caseid}`,
        {
          method: "POST",
          body: JSON.stringify(re),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //update the field
        setValidate({
          isApproved: data.isApproved,
          isAdminRequired: data.isAdminRequired,
        });
        setIsOtp(false);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onGotoCases = () => {
    navigate(`/case-details/${caseid}`);
  };
  const onCloseOtp = () => {
    setIsOtp(false);
    //change tab to something else
  };

  const handleVerifyOtp = () => {
    if (otp.length === 6) {
      onValidateToken();
    }
  };

  return (
    <div>
      <div className="multiform">
        {/* <div className="flow">
          <div className="itemgroup">
            <FlowItem
              flow={flow}
              pos={1}
              code="search"
              title={`Search for Case`}
            />
            <FlowItem
              flow={flow}
              pos={2}
              code="parties"
              title={`Parties`}
              isLast={true}
            />
          </div>
        </div> */}
        {flow.code == "search" && (
          <div className="view">
            {/* <CaseSearch  onSearch={onSearch} frequentData={frequentData}/> */}
            <CustomSearchSortHeader
              onSearch={onSearch}
              frequentData={frequentData}
              isSearchOnly
            />
            {cases?.length == 0 && <JisEmptyList />}
            {cases?.length > 0 && (
              <div>
                {/* <div class="section-cases">
                  <span>Search Results ({count})</span>
                </div> */}

                <div className="table-header">
                  <p>Case Association</p>
                </div>
                <div className="table-wrapper">
                  <table className="case-details-table full-border">
                    <thead>
                      <tr>
                        <th className="col-title">Suit Number</th>
                        <th className="col-title">Case Title</th>
                        <th className="col-title">Case Type</th>
                        <th className="col-medium">Category</th>
                        <th className="col-medium">Division</th>
                        <th className="col-medium">Date Filed </th>
                        <th className="col-medium">Case Status</th>
                        {/* <th className="col-title">Details</th> */}
                        <th className="col-action">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cases?.map((opt, index) => (
                        <tr key={index}>
                          <td>{opt.caseNumber ?? opt.referenceNumber}</td>
                          <td>{opt.caseTitle || "N/A"}</td>
                          <td>
                            {Constants.getItemById(
                              frequentData?.casetype,
                              opt.caseTypeId,
                            )?.caseType1 || "N/A"}
                          </td>
                          <td>
                            {" "}
                            {Constants.getItemById(
                              frequentData?.casecategories,
                              opt.caseCategoryId,
                            )?.categoryTitle || "N/A"}
                          </td>
                          <td>
                            {" "}
                            {Constants.getItemById(
                              frequentData?.divisions,
                              opt.divisionId,
                            )?.title || "N/A"}
                          </td>
                          <td>
                            {" "}
                            {Constants.momentDate(opt.createdOn).format(
                              "DD MMM, YYYY",
                            ) || "N/A"}
                          </td>
                          <td>
                            {Constants.getItemById(
                              frequentData?.casestatuses,
                              opt.caseStatusId,
                            )?.description || "N/A"}
                          </td>
                          {/* <td><JisButton onClick={()=>onContinue(opt.caseId)}>View</JisButton></td> */}
                          <td>
                            <JisButton
                              variant="plain"
                              onClick={() => onContinue(opt.caseId)}
                            >
                              Join Case
                            </JisButton>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        )}

        {flow.code == "parties" && (
          <div className="view">
            <div>
              <div className="labeltext">
                <span>Suit Number</span>
                <span>{cinfo?.caseNumber}</span>
              </div>
              <div className="labeltext">
                {" "}
                <span>Parties to the case</span>
                <span>{cinfo?.caseTitle?.toUpperCase()}</span>
              </div>
            </div>
            <div className="panel">
              <div className="title"> Case Parties</div>
              <div>
                <div className="panel-body">
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {parties?.map((opt, index) => (
                      <div key={index} style={{ width: "40%", margin: 16 }}>
                        <JisCheckbox
                          label={`${opt.firstName} ${opt.lastName ?? ""}`}
                          disabled={opt.legalCounselId == profile.id}
                          onChange={(e) => onCheck(e, opt.id)}
                          value={selected.has(opt.id)}
                        />
                        <div>
                          {opt.legalCounselId == profile.id && (
                            <span
                              className="note"
                              style={{
                                color: "black",
                              }}
                            >
                              {" "}
                              You are already the legal counsel associated to
                              this party
                            </span>
                          )}
                          {opt.legalCounselId != null &&
                            opt.legalCounselId != profile.id && (
                              <span
                                className="note"
                                style={{
                                  color: "black",
                                }}
                              >
                                {" "}
                                Already have an existing Legal Counsel
                                associated, you may need an approval from the
                                admin to be associated to this case.
                              </span>
                            )}
                        </div>
                      </div>
                    ))}
                    <div style={{ width: "40%", textAlign: "center" }}>
                      <JisButton variant="outline" onClick={onAddParty}>
                        Add Party
                      </JisButton>
                    </div>
                  </div>
                </div>
                <div className="buttongroup">
                  <JisButton onClick={on_back_search}>Back</JisButton>
                  <JisButton onClick={onSaveAssociation}>
                    Generate Token
                  </JisButton>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {isOtp && (
        <JisDialogForm title="OTP Verification" onClose={onCloseOtp}>
          <div className="otp-modal-container">
            {/* <p className="note">A Token has been sent to your email</p>
            <div>
              <strong>Enter the Token sent to your email</strong>
            </div> */}
            <p className="otp-modal-header-text">Enter OTP Sent to your Mail</p>
            <OTPInput length={6} onChange={setOtp} />
            <div>
              {err != "" && <div className="error">{err}</div>}

              <p className="otp-resend-link">
                Didn't get the Token?{" "}
                {/* <strong className="action_text">Resend Token</strong>{" "} */}
                <button
                  onClick={onSaveAssociation}
                  className="action_text"
                  disabled={isResending}
                >
                  {isResending ? "Sending..." : "Resend Token"}
                </button>{" "}
              </p>
            </div>

            <button
              className="otp-resend-button"
              onClick={handleVerifyOtp}
              disabled={otp.length !== 6}
            >
              Proceed
            </button>
          </div>
        </JisDialogForm>
      )}

      {isPreview && (
        <div className={"preview open"} style={{ overflow: "scroll" }}>
          <div className="heading">
            <div className="buttongroup">
              <JisButton icon="close" onClick={() => setIsPreview(false)}>
                {" "}
                Close Preview
              </JisButton>
            </div>
            <div className="panel">
              <div className="title">Add Party</div>
              <div className="panel-body">
                <JisParty defaultParty={party} onSave={onSaveParty} />
              </div>
            </div>
          </div>
        </div>
      )}

      <BackLoader open={loading} />

      {validate != null && (
        <JisDialog title="Success">
          {validate.isAdminRequired && (
            <p>
              The Case Association is approved. But it still requires Admin to
              approve.
            </p>
          )}
          {!validate.isAdminRequired && (
            <p>
              The Case Association is approved. goto my cases to see it on your
              queue
            </p>
          )}
          <JisButton onClick={onGotoCases}>Goto My Cases</JisButton>
        </JisDialog>
      )}
    </div>
  );
}

export default CaseAssociationRequest;
